import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const services = [
    {
      title: 'HVAC Services',
      description: 'Complete heating, ventilation, and air conditioning solutions for residential and commercial properties',
      image: 'https://public.readdy.ai/ai/img_res/dfce3c0665c8f6da8b6a7fa581d66e96.jpg',
      link: '/services/hvac'
    },
    {
      title: 'MEP Services',
      description: 'Comprehensive mechanical, electrical, and plumbing services for all types of buildings',
      image: 'https://readdy.ai/api/search-image?query=skilled%20engineer%20working%20on%20mechanical%20electrical%20plumbing%20systems%20in%20modern%20building%20with%20clean%20white%20background%20showing%20professional%20mep%20installation%20work%20and%20technical%20equipment&width=800&height=600&seq=mep1&orientation=landscape',
      link: '/services/mep'
    },
    {
      title: 'Electrical Works',
      description: 'Professional electrical installation, maintenance, and repair services',
      image: 'https://readdy.ai/api/search-image?query=professional%20electrician%20installing%20electrical%20systems%20and%20wiring%20in%20commercial%20space%20with%20clean%20white%20background%20showing%20modern%20electrical%20panels%20and%20professional%20tools&width=800&height=600&seq=electrical1&orientation=landscape',
      link: '/services/electrical'
    },
    {
      title: 'Painting Services',
      description: 'High-quality interior and exterior painting for residential and commercial spaces',
      image: 'https://readdy.ai/api/search-image?query=professional%20painter%20applying%20paint%20on%20commercial%20building%20walls%20with%20clean%20white%20background%20showing%20quality%20painting%20equipment%20and%20smooth%20finish%20work&width=800&height=600&seq=painting1&orientation=landscape',
      link: '/services/painting'
    },
    {
      title: 'Ducting Services',
      description: 'Expert duct installation and maintenance for optimal air distribution',
      image: 'https://readdy.ai/api/search-image?query=technician%20installing%20modern%20hvac%20ductwork%20system%20in%20commercial%20building%20with%20clean%20white%20background%20showing%20professional%20ducting%20installation%20and%20ventilation%20equipment&width=800&height=600&seq=ducting1&orientation=landscape',
      link: '/services/ducting'
    },
    {
      title: 'VRF Systems',
      description: 'Variable refrigerant flow systems installation and maintenance',
      image: 'https://readdy.ai/api/search-image?query=modern%20vrf%20air%20conditioning%20system%20installation%20in%20commercial%20building%20with%20clean%20white%20background%20showing%20advanced%20climate%20control%20technology%20and%20professional%20setup&width=800&height=600&seq=vrf1&orientation=landscape',
      link: '/vrf-services'
    },
    {
      title: 'Chiller Maintenance',
      description: 'Professional chiller maintenance and repair services',
      image: 'https://readdy.ai/api/search-image?query=technician%20performing%20maintenance%20on%20industrial%20chiller%20system%20with%20clean%20white%20background%20showing%20professional%20cooling%20equipment%20and%20maintenance%20tools&width=800&height=600&seq=chiller1&orientation=landscape',
      link: '/services/chiller'
    },
    {
      title: 'Mechanical Spare Parts',
      description: 'Quality mechanical spare parts supply for all your needs',
      image: 'https://readdy.ai/api/search-image?query=organized%20display%20of%20mechanical%20spare%20parts%20and%20components%20on%20clean%20white%20background%20showing%20various%20hvac%20and%20mechanical%20equipment%20parts%20professionally%20arranged&width=800&height=600&seq=spares1&orientation=landscape',
      link: '/services/spare-parts'
    }
  ];

  const portfolioProjects = [
    { srNo: '01', name: 'Marina Mall, Abu Dhabi', scope: 'MEP' },
    { srNo: '02', name: 'Dubai Islamic Bank, Abu Dhabi', scope: 'MEP' },
    { srNo: '03', name: 'Emirates Aluminum. EMAL', scope: 'MEP' },
    { srNo: '04', name: 'Al Foah Dates Factory, Mirfa', scope: 'MEP' },
    { srNo: '05', name: 'Qatara Masjid, Al Ain', scope: 'HVAC' },
    { srNo: '06', name: 'Al Khazna Insurance Company, Abu Dhabi', scope: 'MEP' },
    { srNo: '07', name: 'Al Ain Hospital, Ducting Work', scope: 'HVAC' },
    { srNo: '08', name: 'Abu Dhabi, Food Control Authority', scope: 'HVAC' },
    { srNo: '09', name: 'Kuwaiti Embassy, Abu Dhabi', scope: 'HVAC' },
    { srNo: '10', name: 'Abu Dhabi Shipping Comp, Abu Dhabi', scope: 'MEP' },
    { srNo: '11', name: 'National Juice Factory, Al Ain', scope: 'MEP' },
    { srNo: '12', name: 'Al Ain, Hilton Hotel', scope: 'MEP' },
    { srNo: '13', name: 'Al Ain Mall, Al Ain', scope: 'MEP' },
    { srNo: '14', name: 'Ettihad Flight Academy, Al Ain Airport', scope: 'MEP' },
    { srNo: '15', name: 'Caravan Restaurant, Remal Mall, Al Ain', scope: 'MEP' },
    { srNo: '16', name: 'Apple Bees Restaurant, Al Ain Mall', scope: 'MEP' },
    { srNo: '17', name: 'H.H. Shaikha Latifa Palace, Al Ain', scope: 'MEP' },
    { srNo: '18', name: 'ADNOC Office', scope: 'HVAC' },
    { srNo: '19', name: 'Geneva Gallery, Al Ain Mall', scope: 'HVAC' },
    { srNo: '20', name: 'TARCHY Restaurant, Al Ain Mall', scope: 'HVAC' },
    { srNo: '21', name: 'Cooridor Properties', scope: 'MEP' },
    { srNo: '22', name: 'Rashad Al Mansoori, Abu Dhabi', scope: 'MEP' },
    { srNo: '23', name: 'Ministry of Interior. MOI, Sharjah', scope: 'HVAC' },
    { srNo: '24', name: 'Shk.Hamdan Palace, Al Ain (JCI)', scope: 'MEP' }
  ];

  const projectImages = [
    'https://readdy.ai/api/search-image?query=modern%20commercial%20building%20hvac%20installation%20project%20with%20professional%20air%20conditioning%20units%20and%20ductwork%20on%20clean%20white%20background%20showing%20completed%20quality%20work&width=600&height=400&seq=project1&orientation=landscape',
    'https://readdy.ai/api/search-image?query=industrial%20chiller%20system%20installation%20in%20large%20commercial%20facility%20with%20clean%20white%20background%20showing%20professional%20mechanical%20equipment%20and%20piping%20work&width=600&height=400&seq=project2&orientation=landscape',
    'https://readdy.ai/api/search-image?query=electrical%20panel%20installation%20and%20wiring%20work%20in%20commercial%20building%20with%20clean%20white%20background%20showing%20professional%20electrical%20systems%20and%20components&width=600&height=400&seq=project3&orientation=landscape',
    'https://readdy.ai/api/search-image?query=vrf%20air%20conditioning%20system%20installed%20in%20modern%20office%20building%20with%20clean%20white%20background%20showing%20multiple%20indoor%20units%20and%20professional%20installation&width=600&height=400&seq=project4&orientation=landscape',
    'https://readdy.ai/api/search-image?query=commercial%20painting%20project%20showing%20freshly%20painted%20interior%20walls%20and%20ceilings%20with%20clean%20white%20background%20and%20professional%20finish%20quality&width=600&height=400&seq=project5&orientation=landscape',
    'https://readdy.ai/api/search-image?query=hvac%20ductwork%20installation%20in%20commercial%20ceiling%20space%20with%20clean%20white%20background%20showing%20professional%20ducting%20system%20and%20insulation%20work&width=600&height=400&seq=project6&orientation=landscape',
    'https://readdy.ai/api/search-image?query=mechanical%20room%20with%20organized%20piping%20and%20hvac%20equipment%20installation%20on%20clean%20white%20background%20showing%20professional%20mep%20systems%20layout&width=600&height=400&seq=project7&orientation=landscape',
    'https://readdy.ai/api/search-image?query=split%20air%20conditioning%20units%20installed%20on%20building%20exterior%20wall%20with%20clean%20white%20background%20showing%20professional%20hvac%20installation%20work&width=600&height=400&seq=project8&orientation=landscape',
    'https://readdy.ai/api/search-image?query=industrial%20ventilation%20system%20with%20large%20fans%20and%20ductwork%20on%20clean%20white%20background%20showing%20professional%20air%20circulation%20equipment%20installation&width=600&height=400&seq=project9&orientation=landscape',
    'https://readdy.ai/api/search-image?query=commercial%20building%20electrical%20distribution%20system%20with%20panels%20and%20wiring%20on%20clean%20white%20background%20showing%20professional%20electrical%20infrastructure&width=600&height=400&seq=project10&orientation=landscape',
    'https://readdy.ai/api/search-image?query=chiller%20plant%20room%20with%20cooling%20equipment%20and%20piping%20systems%20on%20clean%20white%20background%20showing%20professional%20mechanical%20installation%20work&width=600&height=400&seq=project11&orientation=landscape',
    'https://readdy.ai/api/search-image?query=modern%20office%20space%20with%20installed%20ceiling%20cassette%20air%20conditioning%20units%20on%20clean%20white%20background%20showing%20professional%20hvac%20comfort%20solutions&width=600&height=400&seq=project12&orientation=landscape',
    'https://readdy.ai/api/search-image?query=warehouse%20hvac%20system%20installation%20with%20large%20ductwork%20and%20equipment%20on%20clean%20white%20background%20showing%20industrial%20climate%20control%20solutions&width=600&height=400&seq=project13&orientation=landscape',
    'https://readdy.ai/api/search-image?query=commercial%20kitchen%20ventilation%20and%20exhaust%20system%20installation%20on%20clean%20white%20background%20showing%20professional%20ducting%20and%20hood%20work&width=600&height=400&seq=project14&orientation=landscape',
    'https://readdy.ai/api/search-image?query=building%20automation%20and%20control%20systems%20installation%20with%20modern%20panels%20on%20clean%20white%20background%20showing%20professional%20electrical%20and%20control%20work&width=600&height=400&seq=project15&orientation=landscape'
  ];

  const whatsappNumber = '+971506738495';
  const phoneNumbers = ['+971506738495', '+971585308822', '+971566610846'];

  const bgImage = 'https://static.readdy.ai/image/40f4082868c46b06892898a13f9794b5/bc6fd3999fa0bc62c743c1bd69b9ea44.jpeg';
  const newBgImage = 'https://static.readdy.ai/image/40f4082868c46b06892898a13f9794b5/815ee54ab89ffeb341f41028a81ab7f8.jpeg';

  return (
    <div className="min-h-screen bg-white">
      {/* Top Bar */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-500 text-white py-2">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-between items-center text-sm">
            <div className="flex items-center gap-6">
              <a href={`tel:${phoneNumbers[0]}`} className="hover:text-blue-100 transition-colors flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>{phoneNumbers[0]}</span>
              </a>
              <a href="mailto:Goldenrock_uae@yahoo.com" className="hover:text-blue-100 transition-colors flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>Goldenrock_uae@yahoo.com</span>
              </a>
            </div>
            <div className="flex items-center gap-4">
              <a href={`https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}`} target="_blank" rel="noopener noreferrer" className="hover:text-blue-100 transition-colors">
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
              <a href="#" className="hover:text-blue-100 transition-colors">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="hover:text-blue-100 transition-colors">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="hover:text-blue-100 transition-colors">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Header */}
      <header className="bg-white shadow-md sticky top-0 z-50 border-b border-blue-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center gap-3">
              <img src="https://static.readdy.ai/image/40f4082868c46b06892898a13f9794b5/f825deb031b992e693696193511051c7.jpeg" alt="Golden Rock Logo" className="h-16 w-auto" />
              <div>
                <h1 className="text-xl font-bold text-blue-600">GOLDEN ROCK ELECTRO MECHANICAL WORKS L.L.C</h1>
                <p className="text-xs text-gray-700 font-arabic">جولدن روك للأعمال الكهروميكانيكية ذ.م.م</p>
              </div>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-8">
              <a href="#home" className="text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap">Home</a>
              <a href="#services" className="text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap">Services</a>
              <a href="#portfolio" className="text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap">Portfolio</a>
              <a href="#projects" className="text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap">Projects</a>
              <a href="#about" className="text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap">About Us</a>
              <a href="#contact" className="text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap">Contact</a>
              <a href={`https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}`} target="_blank" rel="noopener noreferrer" className="bg-green-500 text-white px-6 py-2 rounded-full hover:bg-green-600 transition-colors flex items-center gap-2 whitespace-nowrap">
                <i className="ri-whatsapp-line text-lg"></i>
                <span>WhatsApp</span>
              </a>
            </nav>

            {/* Mobile Menu Button */}
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden text-blue-600 hover:text-blue-700 w-10 h-10 flex items-center justify-center cursor-pointer"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>

          {/* Mobile Navigation */}
          {mobileMenuOpen && (
            <nav className="lg:hidden py-4 border-t border-blue-200">
              <div className="flex flex-col gap-4">
                <a href="#home" className="text-gray-700 hover:text-blue-600 font-medium transition-colors" onClick={() => setMobileMenuOpen(false)}>Home</a>
                <a href="#services" className="text-gray-700 hover:text-blue-600 font-medium transition-colors" onClick={() => setMobileMenuOpen(false)}>Services</a>
                <a href="#portfolio" className="text-gray-700 hover:text-blue-600 font-medium transition-colors" onClick={() => setMobileMenuOpen(false)}>Portfolio</a>
                <a href="#projects" className="text-gray-700 hover:text-blue-600 font-medium transition-colors" onClick={() => setMobileMenuOpen(false)}>Projects</a>
                <a href="#about" className="text-gray-700 hover:text-blue-600 font-medium transition-colors" onClick={() => setMobileMenuOpen(false)}>About Us</a>
                <a href="#contact" className="text-gray-700 hover:text-blue-600 font-medium transition-colors" onClick={() => setMobileMenuOpen(false)}>Contact</a>
                <a href={`https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}`} target="_blank" rel="noopener noreferrer" className="bg-green-500 text-white px-6 py-2 rounded-full hover:bg-green-600 transition-colors flex items-center justify-center gap-2 whitespace-nowrap">
                  <i className="ri-whatsapp-line text-lg"></i>
                  <span>WhatsApp</span>
                </a>
              </div>
            </nav>
          )}
        </div>
      </header>

      {/* Hero Section */}
      <section id="home" className="relative text-white py-32" style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="absolute inset-0 bg-blue-900/80"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <h2 className="text-5xl font-bold mb-6 leading-tight text-white">Golden Rock Electro Mechanical Works groups of companies </h2>
            <p className="text-xl mb-8 text-blue-50">Your trusted partner for HVAC, MEP, Electrical, Painting, Ducting, VRF, Chiller Maintenance, and Mechanical Spare Parts in UAE</p>
            <div className="flex flex-wrap gap-4">
              <a href="#contact" className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap">Get a Quote</a>
              <a href="https://wehlrg.readdy.co/#services" className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold hover:bg-blue-50 transition-colors whitespace-nowrap">Our Services</a>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 relative" style={{ backgroundImage: `url(${newBgImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="absolute inset-0 bg-white/95"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-blue-600 mb-4">OUR SERVICES</h2>
            <p className="text-xl text-gray-700">Comprehensive electro mechanical solutions for all your needs</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-white border border-blue-200 rounded-lg shadow-lg overflow-hidden hover:shadow-2xl hover:border-blue-400 transition-all group cursor-pointer">
                <div className="relative h-64 overflow-hidden">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-blue-600 mb-3">{service.title}</h3>
                  <p className="text-gray-700 mb-4">{service.description}</p>
                  <a href={service.link} className="text-blue-600 font-semibold hover:text-blue-700 transition-colors inline-flex items-center gap-2 whitespace-nowrap">
                    Learn More <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Portfolio Section */}
      <section id="portfolio" className="py-20 relative" style={{ backgroundImage: `url(${newBgImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="absolute inset-0 bg-white/95"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-blue-600 mb-4">OUR PORTFOLIO</h2>
            <p className="text-xl text-gray-700">Major projects completed across UAE</p>
          </div>

          <div className="bg-white border border-blue-200 rounded-lg shadow-lg overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gradient-to-r from-blue-600 to-blue-500 text-white">
                  <tr>
                    <th className="px-6 py-4 text-left text-sm font-semibold">S/R No.</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">Job Name</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">Scope</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-blue-100">
                  {portfolioProjects.map((project, index) => (
                    <tr key={index} className="hover:bg-blue-50 transition-colors">
                      <td className="px-6 py-4 text-sm font-medium text-blue-600">{project.srNo}</td>
                      <td className="px-6 py-4 text-sm text-gray-700">{project.name}</td>
                      <td className="px-6 py-4">
                        <span className={`inline-flex px-3 py-1 rounded-full text-xs font-semibold ${
                          project.scope === 'MEP' 
                            ? 'bg-blue-500 text-white' 
                            : 'bg-green-500 text-white'
                        }`}>
                          {project.scope}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="mt-12 text-center">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-gradient-to-br from-blue-600 to-blue-500 text-white p-8 rounded-lg shadow-lg">
                <div className="text-5xl font-bold mb-2">24+</div>
                <div className="text-lg">Major Projects</div>
              </div>
              <div className="bg-gradient-to-br from-blue-600 to-blue-500 text-white p-8 rounded-lg shadow-lg">
                <div className="text-5xl font-bold mb-2">15+</div>
                <div className="text-lg">Years Experience</div>
              </div>
              <div className="bg-gradient-to-br from-blue-600 to-blue-500 text-white p-8 rounded-lg shadow-lg">
                <div className="text-5xl font-bold mb-2">100%</div>
                <div className="text-lg">Client Satisfaction</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Gallery */}
      <section id="projects" className="py-20 relative" style={{ backgroundImage: `url(${newBgImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="absolute inset-0 bg-white/95"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-blue-600 mb-4">OUR PROJECTS</h2>
            <p className="text-xl text-gray-700">Showcasing our expertise and quality workmanship</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {projectImages.map((image, index) => (
              <div key={index} className="relative h-80 rounded-lg overflow-hidden shadow-lg border border-blue-200 group cursor-pointer">
                <img 
                  src={image} 
                  alt={`Project ${index + 1}`}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/90 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-6">
                  <p className="text-white font-semibold text-lg">Project {index + 1}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 relative" style={{ backgroundImage: `url(${newBgImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="absolute inset-0 bg-white/95"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-blue-600 mb-6">About Golden Rock</h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Golden Rock Electro Mechanical Works L.L.C is a leading group of companies specializing in comprehensive electro mechanical solutions across the UAE. With years of experience and a commitment to excellence, we have established ourselves as a trusted partner for businesses and organizations seeking reliable HVAC, MEP, electrical, and mechanical services.
              </p>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Our team of highly skilled professionals brings expertise in HVAC systems, MEP services, electrical installations, painting, ducting, VRF systems, chiller maintenance, and mechanical spare parts supply. We pride ourselves on delivering quality workmanship, timely project completion, and exceptional customer service.
              </p>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                At Golden Rock, we understand the importance of maintaining optimal building performance and comfort. Whether you need installation, maintenance, or repair services, our dedicated team is ready to provide customized solutions that meet your specific requirements and exceed your expectations.
              </p>
              <div className="flex flex-wrap gap-4">
                <div className="bg-gradient-to-br from-blue-600 to-blue-500 text-white px-6 py-4 rounded-lg">
                  <div className="text-3xl font-bold mb-1">15+</div>
                  <div className="text-sm">Years Experience</div>
                </div>
                <div className="bg-gradient-to-br from-blue-600 to-blue-500 text-white px-6 py-4 rounded-lg">
                  <div className="text-3xl font-bold mb-1">500+</div>
                  <div className="text-sm">Projects Completed</div>
                </div>
                <div className="bg-gradient-to-br from-blue-600 to-blue-500 text-white px-6 py-4 rounded-lg">
                  <div className="text-3xl font-bold mb-1">100%</div>
                  <div className="text-sm">Client Satisfaction</div>
                </div>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=professional%20team%20of%20hvac%20and%20mechanical%20engineers%20in%20modern%20office%20with%20clean%20white%20background%20showing%20diverse%20skilled%20technicians%20and%20equipment&width=800&height=1000&seq=about1&orientation=portrait" 
                alt="Golden Rock Team"
                className="w-full h-auto rounded-lg shadow-2xl border-2 border-blue-200 object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 relative" style={{ backgroundImage: `url(${newBgImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="absolute inset-0 bg-white/95"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-blue-600 mb-4">CONTACT US</h2>
            <p className="text-xl text-gray-700">Get in touch with our team for professional electro mechanical solutions</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h3 className="text-2xl font-bold text-blue-600 mb-6">Get In Touch</h3>
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-500 text-white rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-blue-600 mb-2">Phone Numbers</h4>
                    {phoneNumbers.map((phone, index) => (
                      <a key={index} href={`tel:${phone}`} className="block text-gray-700 hover:text-blue-600 transition-colors mb-1">
                        {phone}
                      </a>
                    ))}
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-500 text-white rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-blue-600 mb-2">Email</h4>
                    <a href="mailto:Goldenrock_uae@yahoo.com" className="text-gray-700 hover:text-blue-600 transition-colors">
                      Goldenrock_uae@yahoo.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-500 text-white rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-blue-600 mb-2">Location</h4>
                    <p className="text-gray-700">United Arab Emirates</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-green-500 text-white rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-whatsapp-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-blue-600 mb-2">WhatsApp</h4>
                    <a href={`https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}`} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-green-600 transition-colors">
                      {whatsappNumber}
                    </a>
                  </div>
                </div>
              </div>

              <div className="mt-8">
                <h4 className="font-semibold text-blue-600 mb-4">Follow Us</h4>
                <div className="flex gap-4">
                  <a href="#" className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-500 text-white rounded-full flex items-center justify-center hover:from-blue-700 hover:to-blue-600 transition-all cursor-pointer">
                    <i className="ri-facebook-fill text-xl"></i>
                  </a>
                  <a href="#" className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-500 text-white rounded-full flex items-center justify-center hover:from-blue-700 hover:to-blue-600 transition-all cursor-pointer">
                    <i className="ri-instagram-line text-xl"></i>
                  </a>
                  <a href="#" className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-500 text-white rounded-full flex items-center justify-center hover:from-blue-700 hover:to-blue-600 transition-all cursor-pointer">
                    <i className="ri-linkedin-fill text-xl"></i>
                  </a>
                  <a href={`https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}`} target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-green-500 text-white rounded-full flex items-center justify-center hover:bg-green-600 transition-colors cursor-pointer">
                    <i className="ri-whatsapp-line text-xl"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white border border-blue-200 p-8 rounded-lg shadow-lg">
              <h3 className="text-2xl font-bold text-blue-600 mb-6">Send Us a Message</h3>
              <form className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">Name</label>
                  <input 
                    type="text" 
                    id="name" 
                    name="name"
                    className="w-full px-4 py-3 bg-white border border-blue-200 text-gray-900 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                    placeholder="Your Name"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                  <input 
                    type="email" 
                    id="email" 
                    name="email"
                    className="w-full px-4 py-3 bg-white border border-blue-200 text-gray-900 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                    placeholder="your@email.com"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">Phone</label>
                  <input 
                    type="tel" 
                    id="phone" 
                    name="phone"
                    className="w-full px-4 py-3 bg-white border border-blue-200 text-gray-900 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                    placeholder="+971 XX XXX XXXX"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="service" className="block text-sm font-medium text-gray-700 mb-2">Service Required</label>
                  <select 
                    id="service" 
                    name="service"
                    className="w-full px-4 py-3 pr-8 bg-white border border-blue-200 text-gray-900 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all appearance-none cursor-pointer"
                    required
                  >
                    <option value="">Select a service</option>
                    <option value="hvac">HVAC Services</option>
                    <option value="mep">MEP Services</option>
                    <option value="electrical">Electrical Works</option>
                    <option value="painting">Painting Services</option>
                    <option value="ducting">Ducting Services</option>
                    <option value="vrf">VRF Systems</option>
                    <option value="chiller">Chiller Maintenance</option>
                    <option value="spares">Mechanical Spare Parts</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">Message</label>
                  <textarea 
                    id="message" 
                    name="message"
                    rows={4}
                    className="w-full px-4 py-3 bg-white border border-blue-200 text-gray-900 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all resize-none"
                    placeholder="Tell us about your project..."
                    required
                  ></textarea>
                </div>
                <button 
                  type="submit" 
                  className="w-full bg-gradient-to-r from-blue-600 to-blue-500 text-white px-8 py-4 rounded-lg font-semibold hover:from-blue-700 hover:to-blue-600 transition-all whitespace-nowrap cursor-pointer"
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative text-gray-700 py-12" style={{ backgroundImage: `url(${newBgImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="absolute inset-0 bg-white/95"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <img src="https://static.readdy.ai/image/40f4082868c46b06892898a13f9794b5/f825deb031b992e693696193511051c7.jpeg" alt="Golden Rock Logo" className="h-12 w-auto" />
                <div>
                  <h3 className="text-lg font-bold text-blue-600">GOLDEN ROCK</h3>
                  <p className="text-xs text-gray-600">Electro Mechanical Works</p>
                </div>
              </div>
              <p className="text-gray-600 text-sm">
                Your trusted partner for comprehensive electro mechanical solutions in UAE.
              </p>
            </div>

            <div>
              <h4 className="text-lg font-semibold text-blue-600 mb-4">Services</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="#" className="text-gray-600 hover:text-blue-600 transition-colors">HVAC Services</a></li>
                <li><a href="#" className="text-gray-600 hover:text-blue-600 transition-colors">MEP Services</a></li>
                <li><a href="#" className="text-gray-600 hover:text-blue-600 transition-colors">Electrical Works</a></li>
                <li><a href="#" className="text-gray-600 hover:text-blue-600 transition-colors">Painting Services</a></li>
                <li><a href="#" className="text-gray-600 hover:text-blue-600 transition-colors">Ducting Services</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold text-blue-600 mb-4">Quick Links</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="#home" className="text-gray-600 hover:text-blue-600 transition-colors">Home</a></li>
                <li><a href="#services" className="text-gray-600 hover:text-blue-600 transition-colors">Services</a></li>
                <li><a href="#portfolio" className="text-gray-600 hover:text-blue-600 transition-colors">Portfolio</a></li>
                <li><a href="#projects" className="text-gray-600 hover:text-blue-600 transition-colors">Projects</a></li>
                <li><a href="#about" className="text-gray-600 hover:text-blue-600 transition-colors">About Us</a></li>
                <li><a href="#contact" className="text-gray-600 hover:text-blue-600 transition-colors">Contact</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold text-blue-600 mb-4">Contact Info</h4>
              <ul className="space-y-3 text-sm">
                {phoneNumbers.map((phone, index) => (
                  <li key={index}>
                    <a href={`tel:${phone}`} className="text-gray-600 hover:text-blue-600 transition-colors flex items-center gap-2">
                      <i className="ri-phone-line"></i>
                      {phone}
                    </a>
                  </li>
                ))}
                <li>
                  <a href="mailto:Goldenrock_uae@yahoo.com" className="text-gray-600 hover:text-blue-600 transition-colors flex items-center gap-2">
                    <i className="ri-mail-line"></i>
                    Goldenrock_uae@yahoo.com
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-blue-200 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-600 text-sm">© 2024 Golden Rock Electro Mechanical Works L.L.C - All Rights Reserved</p>
            <div className="flex gap-4">
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue-600 transition-colors text-sm">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Floating WhatsApp Button */}
      <a 
        href={`https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 w-16 h-16 bg-green-500 text-white rounded-full flex items-center justify-center shadow-lg hover:bg-green-600 transition-all hover:scale-110 z-50 cursor-pointer"
        aria-label="Contact us on WhatsApp"
      >
        <i className="ri-whatsapp-line text-3xl"></i>
      </a>

      {/* Floating Call Button */}
      <a 
        href={`tel:${phoneNumbers[0]}`}
        className="fixed bottom-24 right-6 w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-500 text-white rounded-full flex items-center justify-center shadow-lg hover:from-blue-700 hover:to-blue-600 transition-all hover:scale-110 z-50 cursor-pointer"
        aria-label="Call us"
      >
        <i className="ri-phone-line text-2xl"></i>
      </a>
    </div>
  );
}
